module.exports = __webpack_public_path__ + "static/icons/icon-my-snow-103a871ba1ccc5c886710b491e33ec25.svg";